import {dataChanged, showModalEntryForm} from './entry-modal.js';

let ElSelected = []
$.extend($.fn.datepicker.defaults, {
  autoclose: true,
  format: 'dd/mm/yyyy',
  orientation: 'bottom',
});
$.notifyDefaults({'z_index': 10099});

$.Autocomplete.defaults.serviceUrl = function () {
  if (typeof this.dataset.serviceUrl === 'undefined') {
    throw new Error(`No suggestion URL defined for '${this.name}'`);
  }
  return window.location.origin + this.dataset.serviceUrl;
};

$('input[name="link-cases"]:radio').change(function () {
  $('#duplicate_submit').removeClass('disabled');
});
$('#duplicate_dialog').on('shown.bs.modal', function () {
  $('#duplicate_dialog input[type="radio"]').prop('checked', false);
  $('#duplicate_submit').addClass('disabled');
});
$('#link_dialog').on('shown.bs.modal', function () {
  $('#id_available_entry').focus()
})
$("a[href='#top']").click(function (event) {
  event.preventDefault();
  $("html, body").animate({scrollTop: 0}, 'slow', function (x, t, b, c, d) {
    let s = 1.70158;
    let p = 0;
    let a = c;
    if (t == 0) return b;
    if ((t /= d / 2) == 2) return b + c;
    if (!p) p = d * (.3 * 1.5);
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else s = p / (2 * Math.PI) * Math.asin(c / a);
    if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
  });
  return false;
});


/* Keyboard shortcut */
document.addEventListener("keydown", function (event) {
  // CTRL + S
  if (event.ctrlKey && event.keyCode == 83) {
    event.stopPropagation();
    event.preventDefault();
    $('#action-save').click()
  }
});

$(document).ready(function () {
  let href_exceptions = window.__link_list;

  $('a').click(function (e) {
    if ($.inArray($(this).attr('href'), href_exceptions) == -1) {
      if (!$(this).attr('data-is-form-link')) {
        if (dataChanged()) {
          e.preventDefault();
          e.stopPropagation();
          showModalEntryForm($(this), '');
        }
      }
    }
  });
});

// when clicking on the glyph on the list we access directly the gallery
$('.a-photos-carousel').click(function (e) {
   e.preventDefault()
   $('#gallery-' + $(this).attr('data-id') + ' img').first().trigger("click")
})

//Show modal on condition
function showModalNewUser($post, $id, element, url) {

//Check elements sending receive an <a> element
  function process_continue() {

    //If element its modal, don't have any url, then print the other modal after choice button.
    if (element !== undefined && element != '') {
      if (element.attr('href')) {
        url = element.attr('href');
      } else if (element.attr('data-toggle') && element.attr('data-toggle') == 'modal') {
        $(element.attr('data-target')).modal('show');
      }
    }

    if (url !== undefined && url != '') {
      window.location = url;
    }
  }

//Show modal on pressing trash icon
  $id.modal('show');

//Continue button
  $('#unsaved_modal').click(function (e) {
    process_continue()
  });

  //Save and continue button.
  $('#saved_modal').click(function (e) {
    $('#loading').addClass('loading');
    $id.modal('hide');
    $.ajax({
      type: "POST",
      url: window.location,
      data: $post.serialize(),
      success: function (msg) {
        process_continue()
      },
      error: function () {
        $("#error").show();
      },
      complete: function () {
        $('#loading').removeClass('loading');
      }
    });
  });

}

$('.remove_new_user').click(function (e) {
  $('#modal_text').text('Are you sure you want to remove user ' + $(this).attr("id"));
  e.preventDefault();
  e.stopPropagation();

  showModalNewUser('', $('#remove_new_user_modal'), $(this), '');

});

$(function () {
  $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).parent().siblings().removeClass('open');
    $(this).parent().toggleClass('open');
  });

  // EDQM Customization
  $(".navbar .nav li").hover(function () {
    $(this).toggleClass("active");
  });

  $(".navbar .nav li").click(function () {
    window.location = $(this).find('a').attr('href');
  })
});

String.prototype.endsWith = function (needle) {
  return needle === this.substr(0 - needle.length);
}

window.form_has_changed = function (form) {

  // get form
  if (typeof form == "string") form = document.getElementById(form);
  if (!form || !form.nodeName || form.nodeName.toLowerCase() != "form") return null;
  // find changed elements
  let changed = [], n, c, def, o, ol, opt;
  for (let e = 0, el = form.elements.length; e < el; e++) {
    n = form.elements[e];
    c = false;
    switch (n.nodeName.toLowerCase()) {
      // select boxes
      case "select":
        def = 0;
        for (o = 0, ol = n.options.length; o < ol; o++) {
          opt = n.options[o];
          c = c || (opt.selected != opt.defaultSelected);
          if (opt.defaultSelected) def = o;
        }
        if (c && !n.multiple) c = (def != n.selectedIndex);
        break;
      // input / textarea
      case "textarea":
      case "input":
        if (n.type == 'hidden') {
          if (document.getElementsByClassName("is-changed").length > 0) {
            changed.push(n);
          }
        }
        switch (n.type.toLowerCase()) {
          case "checkbox":
          case "radio":
            // checkbox / radio
            c = (n.checked != n.defaultChecked);
            break;
          default:
            // standard values
            c = (n.value != n.defaultValue);
            break;
        }
        break;
    }
    if (c) changed.push(n);
  }
  return changed;
}

$.fn.select2.defaults.set("theme", "bootstrap");

function update_organization(el$) {
  if (el$.val() === 'OM') {
    $('#div_id_organization_name').hide();
    $('#div_id_omcl').show();
  } else {
    $('#div_id_omcl').hide();
    $('#div_id_organization_name').show();
  }
}

let organization_type$ = $('#id_organization_type');
update_organization(organization_type$);
organization_type$.on('change', function (e) {
  update_organization($(this));
});


// $('#id_omcl').on('change', function(e) {
//    $('#id_organization_name').val($(this).find('option:selected').text());
// });

function clear_form_elements(ele) {
  $(ele).find(':input').each(function () {
    switch (this.type) {
      case 'password':
      case 'select-multiple':
      case 'select-one':
      case 'text':
      case 'number':
      case 'textarea':
        $(this).val('');
        break;
      case 'checkbox':
      case 'radio':
        this.checked = false;
    }
  });
}

$('a.clear_form').on('click', function () {
  clear_form_elements('#short_search_form');
});

$('#duplicate_submit').on('click', function () {
  $('#duplicate_form').submit();
});

//get all the checkboxes from the column selector
let $checkboxes = $('.row-selector input[type="checkbox"]')

function updateCheckboxesState() {
  //remembers the checkboxes state when navigating other pages
  // TODO remains to be seen if it will be kept
  $checkboxes.each(function(){
    if (this.value !== '' && $('#list_id').val().includes(this.value)) {
      $(this).prop('checked', true);
    } else {
      $(this).prop('checked', false);
    }
  });
}

$('#export_submit').on('click', function () {
  $('#id_selected_fields option').prop('selected', true);
  $('#export_form').submit();
  $('#export_dialog').modal('hide')
  $('#list_id').val('')
  updateCheckboxesState()
});

$('#id_selected_fields').on('dblclick', function () {
  $('#export_remove').click();
});
$('#id_available_fields').on('dblclick', function () {
  $('#export_add').click();
});

$('#link_submit').on('click', function () {
  $('#link_form').submit();

});

$('#remove_link_submit').on('click', function () {
  $('#remove_link_form').submit();

});

function reArrangeSelect() {
  $("#id_available_fields").html($("#id_available_fields option").sort(function (a, b) {
    return a.text.toLowerCase() == b.text.toLowerCase() ? 0 : a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
  }));

  if ($("#id_selected_fields option").length > 0) {
    $('#export_submit').prop('disabled', false);
  } else {
    $('#export_submit').prop('disabled', true);
  }
}

function reArrangeSortby() {
  $("#id_order").html($("#id_order option").sort(function (a, b) {
    return a.text.toLowerCase() == b.text.toLowerCase() ? 0 : a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
  }));
  $("#id_order").val($("#id_order option:first").val());
  reArrangeSelect();
}

reArrangeSelect();

// make sur drop down list is empty before adding new items
$('#id_order').empty();

function add_txt(id_src) {
  let $cl1 = $(id_src).clone();
  let $cl2 = $(id_src).clone();

  $cl1.appendTo('#id_order');
  $('#id_order option').text(function (i, oldText) {
    let value = $(this).val();
    if ((~oldText.indexOf(' (asc)')) || (~oldText.indexOf(' (desc)'))) {
      return oldText;
    } else {
      $(this).val('-' + value);
      return oldText + ' (asc)';
    }
  });

  $cl2.appendTo('#id_order');
  $('#id_order option').text(function (i, oldText) {
    if ((~oldText.indexOf(' (asc)')) || (~oldText.indexOf(' (desc)'))) {
      return oldText;
    } else {
      return oldText + ' (desc)'
    }
  });

  reArrangeSortby();
  return this;
}

add_txt('#id_selected_fields option');

$('#export_add').on('click', function (e) {
  e.preventDefault();

  //apply add_txt to item added
  add_txt('#id_available_fields option:selected');

  $('#id_available_fields option:selected').remove().appendTo('#id_selected_fields');

  reArrangeSelect()
});

$('#export_remove').on('click', function (e) {
  e.preventDefault();
  // get all selected text from #id_selected_fields into list sel_list
  let sel_list = $('#id_selected_fields option:selected').map(function () {
    return $.trim($(this).text());
  }).get();
  //loop over sel_list
  $.each(sel_list, function (j, sel) {
    //when removing from #id_selected_fields we are removing also from #id_order
    $('#id_order option').filter(function () {
      if (~$.trim($(this).text().indexOf(' (asc)'))) {
        return $.trim($(this).text().toLowerCase().replace(' (asc)', '')) === sel.toLowerCase()
      }
      if (~$.trim($(this).text().indexOf(' (desc)'))) {
        return $.trim($(this).text().toLowerCase().replace(' (desc)', '')) === sel.toLowerCase()
      }
    }).remove();

  });

  $('#id_selected_fields option:selected').remove().appendTo('#id_available_fields');
  reArrangeSelect()
});

$('#export_up').on('click', function (e) {
  let up_el = self.$('#id_selected_fields option:selected').first().prev();
  if (up_el.length === 1) {
    let move_el = self.$('#id_selected_fields option:selected').detach();
    up_el.before(move_el);
  }
  $('#id_selected_fields').focus();
  e.preventDefault()
});

$('#export_down').on('click', function (e) {
  let down_el = self.$('#id_selected_fields option:selected').last().next();
  if (down_el.length === 1) {
    let move_el = self.$('#id_selected_fields option:selected').detach();
    down_el.after(move_el);
  }
  $('#id_selected_fields').focus();
  e.preventDefault()
});

//get token value to use it in the ajax request header
let csrftoken = $("[name=csrfmiddlewaretoken]").val()

function handleEntriesSelectionAjax(selectedIds) {
  $.ajax({
    headers: {'X-CSRFToken': csrftoken},
    type: "GET",
    url: window.location,
    data: {
      'selected_id': selectedIds
    },
    'dataType': 'json',
    success: function (msg) {
      //add the entries selected to list_id input
      $('#list_id').val(msg.selected_ids)
    },
  })
}


$('.row-selector.row-selector-all > input[type="checkbox"]').change(function (e) {
  let entriesSelected = []

  $checkboxes.each(function () {
    this.checked = e.target.checked
    if (this.checked && this.value !== '') {
      entriesSelected.push(this.value)
    } else if (!this.checked) {
      entriesSelected = []
    }
  })
  let selectedIds = entriesSelected.join(",");
  handleEntriesSelectionAjax(selectedIds)
})


$('.search-reporting-period').change(function (e) {
  let date_from = $('#id_reporting_date_from').val()
  let date_to = $('#id_reporting_date_to').val()
  if (date_to != '' && date_from != '') {
    if (Date.parse(date_to) < Date.parse(date_from)) {
      $(this).datepicker('update', '');
    }
  }
});

$(document).ready(function () {
  // success login alert message is self-closing after three seconds
  let selectorAlert = $('.alert.alert-success')
  if (selectorAlert.text().length > 0) {  // Checking the text inside alert
    // Condition to check the text match
    if (selectorAlert.text().indexOf('Login succeeded')) {
      selectorAlert.delay(3000).fadeOut('slow', 'linear')
    }
  }

  // Save and continue button.
  $('#post_thread').click(function (e) {
    $('#loading').addClass('loading');
  });

  //Add attr data-is-form-link for modal.
  $('a.add-row').attr('data-is-form-link', true);

  $('#div_id_Search-0-second_value').hide();

  // Submit of search quick form.
  $('#quick_search').submit(function (e) {
    if (dataChanged()) {
      const url = $('#quick_search').attr('data-service-url');
      e.preventDefault();
      e.stopPropagation();
      showModalEntryForm('', url + '?q=' + $('#id_q').val());
    }
  });

});


$('.result-row').on('click', function (e) {
  window.location = $(this).data('url');
});
$('.row-selector, .photos-carousel').on('click', function (e) {
  e.stopPropagation()
});
$('#id_page').on('change', function () {
  if ($(this).val() > $(this).data('max-page')) {
    $(this).val($(this).data('max-page'))
  }
  if ($(this).val() < 1) {
    $(this).val(1)
  }
  this.form.submit();
})

/* Keyboard shortcut */
document.addEventListener("keydown", function (event) {
  let handled = false
  // CTRL + Q
  if (event.ctrlKey && event.keyCode == 81) {
    handled = true;
    $('#id_q').focus()
  }
  // CTRL + F3
  if (event.ctrlKey && event.keyCode == 114) {
    handled = true;
    $('#top-menu-search a').click()
  }
  // CTRL + F5
  if (event.ctrlKey && event.keyCode == 116) {
    handled = true;
    $('#top-menu-result a').click()
  }
  if (handled) {
    event.stopPropagation();
    event.preventDefault();
  }
});

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

$('#export_dialog').on('shown.bs.modal', function () {
  let $selected_rows = $('.row-selector input[type="checkbox"]:checked');
  let $export_selected_choice = $('input[name="export"][value="2"]');
  if ($selected_rows.length > 0 || ($('#list_id').val() !== '')) {
    $export_selected_choice.parent().parent().removeClass('disabled');
    $export_selected_choice.prop('disabled', false);
    $export_selected_choice.prop('checked', true);
  } else {
    $export_selected_choice.parent().parent().addClass('disabled');
    $export_selected_choice.prop('disabled', true);
    if ($export_selected_choice.prop('checked')) {
      $('input[name="export"][value="0"]').prop('checked', true);
    }
  }
})

// when changing checkbox state we send the value to django
$checkboxes.on("change", function () {
  if (this.value !== '')  handleEntriesSelectionAjax(this.value)
})

// update entries checkboxes selection state
updateCheckboxesState()



